import { PcmpRequestCategoriesTable } from '../components/PcmpRequestCategories/PcmpRequestCategoriesTable';

export function PcmpRequestCategoriesPage() {
  return <PcmpRequestCategoriesTable />;
}
